import { Component, OnInit } from '@angular/core';
import {UtilsService} from "../../shared/utils.service";
import {GlobalConfigurationService} from "./global-configuration.service";

@Component({
  selector: 'app-global-configuration',
  templateUrl: './global-configuration.component.html',
  styleUrls: ['./global-configuration.component.scss']
})
export class GlobalConfigurationComponent implements OnInit {

  inProgress: boolean = false;
  isSentryActive: boolean = false;

  constructor(
    private utils: UtilsService,
    private global: GlobalConfigurationService
  ) {}

  ngOnInit() {
    this.inProgress = true;
    this.global.getSettingValueByKey('sentry_kill_switch').then((response) => {
      this.isSentryActive = response && response?.data?.status === 'on';
      this.inProgress = false;
    });
  }

  /**
   * Saves the configuration setting for Sentry kill switch in the global settings.
   *
   * @return {void}
   */
  onSave() {
    if ( this.inProgress ) {
      return;
    }

    this.inProgress = true;

    const newStatus = this.isSentryActive ? 'on' : 'off';
    this.global.updateSettingValueByKey('sentry_kill_switch', { status: newStatus }).then((response) => {
      if(response) {
        this.utils.showToast('Updated global configuration');
      }
      this.inProgress = false;
    });
  }

}
